import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { nomService } from '../../services/api/nom.service';

export const LoginForm = () => {


	const navigate = useNavigate();
	
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');

	const handleSubmit = async (event) => {
		event.preventDefault();

		try {
			
			nomService.getLogin({
				username: username,
				password: password
			}).then(response => {
				if (response) {
					sessionStorage.setItem('sessionToken', response.token);
					sessionStorage.setItem('username', response.userName);
					sessionStorage.setItem('idUtilizator', response.idUtilizator);
					sessionStorage.setItem('numeUtilizator', response.numeUtilizator);
					sessionStorage.setItem('idPartener', response.idPartener);
					sessionStorage.setItem('defaultPartener', response.idPartener);
					sessionStorage.setItem('numePartener', response.numePartener);
					sessionStorage.setItem('configURL', window.apiConfig.url);
					sessionStorage.setItem('finalaizareFisa', response.finalaizareFisa);
					sessionStorage.setItem('idMedic', response.idMedic);
					sessionStorage.setItem('numeMedic', response.numeMedic);

					if (response.rol == 2) {
						navigate('/dashboard/cautare');
					}
					else {
						navigate('/dashboard/cautare-pacient');
					}
				}
			});
			
		}
		catch (error) {
			setError('Numele de utilizator sau parola este incorecta');
		}
	};

	return (
		<div className="wrap pt40 pb30 clearfix">
			<p className="paragraf-l pb5"></p>
			<p className="paragraf-l pb50">Dacă întâmpinaţi probleme ne puteţi contacta la: <strong>0720.111.611</strong></p>
			<h2>Autentificare</h2> 
			<div id="login" className="formular">
				{error && <div>{error}</div>}
				<fieldset>
					<div data-name="error" className="mb15 f14">
						<span data-name="message_box_text"></span>
					</div>
					<p className="clearfix pb10">
						<label className="w75 fl">Utilizator:</label>
						<input
							className="text w200 fl"
							type="text"
							placeholder="Utilizator"
							id="username"
							value={username}
							onChange={(event) => setUsername(event.target.value)}
						/>
					</p>
					<p className="clearfix pb10">
						<label className="w75 fl">Parola:</label>
						<input
							className="text w200 fl"
							type="password"
							placeholder="Parola"
							id="password"
							value={password}
							onChange={(event) => setPassword(event.target.value)}
						/>
					</p>
					<button className="w100 ml75 btn" data-name="submit" name="submit" type="submit" role="button" onClick={handleSubmit}>Autentificare</button>
				</fieldset>
			</div>
		</div>
	);
};

